import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — the flat-roof cap tile: a 1x1 m concrete slab, 0.12 thick,
// with a slightly lighter gravel-grey overlay on top. Exactly one tile in
// both axes so consecutive caps tile seamlessly; authored at y=0 and lifted
// onto 2.6 m walls by the consumer.
const CONCRETE = "#9a9a94";
const GRAVEL = "#b0b0aa";

export const roofFlat = defineModel({
  id: "roof-flat",
  batchId: "modern",
  name: "Flat roof",
  tags: ["modern", "outdoor", "structure", "roof"],
  summary: "A 1x1 flat-roof cap tile with a gravel-grey top.",
  description:
    "The flat-roof cap of the Modern Living kit: a concrete slab exactly " +
    "1x1 m and 0.12 m thick with a lighter gravel top layer. Authored at " +
    "y=0; the consumer lifts it onto 2.6 m walls. Tiles seamlessly.",
  tiles: { w: 1, h: 1 },
  footprint: 0.9,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.12, 1.0), color: CONCRETE, position: [0, 0.06, 0] },
      { geometry: new THREE.BoxGeometry(1.0, 0.02, 1.0), color: GRAVEL, position: [0, 0.13, 0] },
    ];
  },
  animations: [],
});
